import axios from '@/plugins/axiosInstance'
import { googleIntegration } from '@/networking/urlManager'

/**
 * Initiates connection to a social platform
 * @param {number} platformId - ID of the platform to connect
 * @param {string} redirectURL - URL to redirect after authentication
 * @returns {Promise<string>} Redirect URL for OAuth
 */
export const connect = async (platformId, redirectURL) => {
  try {
    const response = await axios.post(googleIntegration.authorize, {
      redirectURL,
      platformId,
    })
    return response.data.data
  } catch (error) {
    throw error
  }
}
